module.exports = __webpack_public_path__ + "img/bionix.42ca7a19.svg";